import { API_BASE, apiFetch, authHeaders, parseApiError } from './apiClient';

export const STATUS_LABELS = {
  IN_PROGRESS: 'En proceso',
  OPEN: 'Sin resolver',
  RESOLVED: 'Resuelto',
};

export const CATEGORY_LABELS = {
  TRIP_ISSUE: 'Problema con viaje',
  PAYMENT: 'Pago',
  ACCOUNT: 'Cuenta',
  APP_TECHNICAL: 'App / técnico',
  OTHER: 'Otro',
};

export function mapSupportTicket(ticket) {
  if (!ticket || typeof ticket !== 'object') return ticket;
  const author = ticket.client || ticket.driver;
  const photoUrl =
    ticket.authorPhotoUrl || author?.profilePhotoUrl || null;

  return {
    ...ticket,
    statusLabel: STATUS_LABELS[ticket.status] || ticket.status,
    categoryLabel: CATEGORY_LABELS[ticket.category] || ticket.category,
    authorPhotoUrl: photoUrl,
    previewText: ticket.description || '',
  };
}

async function fetchJson(url, options = {}) {
  const response = await apiFetch(url, options);
  const payload = await readJson(response);
  if (!response.ok) {
    throw new Error(parseApiError(payload, 'Error al cargar tickets de soporte'));
  }
  return payload;
}

async function readJson(response) {
  try {
    return await response.json();
  } catch {
    return null;
  }
}

export async function fetchSupportTickets(authorType) {
  const query = authorType
    ? `?authorType=${encodeURIComponent(authorType)}`
    : '';
  const payload = await fetchJson(`${API_BASE}/admin/support-tickets${query}`, {
    headers: authHeaders(),
  });
  const list = Array.isArray(payload.tickets) ? payload.tickets : [];
  return list.map(mapSupportTicket);
}

export async function fetchSupportTicketById(ticketId) {
  const payload = await fetchJson(
    `${API_BASE}/admin/support-tickets/${encodeURIComponent(ticketId)}`,
    { headers: authHeaders() },
  );
  return mapSupportTicket(payload.ticket || payload);
}

export async function postSupportTicketMessage(ticketId, body, imageUrl) {
  const payload = await fetchJson(
    `${API_BASE}/admin/support-tickets/${encodeURIComponent(ticketId)}/messages`,
    {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({
        body,
        ...(imageUrl ? { imageUrl } : {}),
      }),
    },
  );
  return mapSupportTicket(payload.ticket || payload);
}

export async function updateSupportTicketStatus(ticketId, status) {
  const payload = await fetchJson(
    `${API_BASE}/admin/support-tickets/${encodeURIComponent(ticketId)}`,
    {
      method: 'PATCH',
      headers: authHeaders(),
      body: JSON.stringify({ status }),
    },
  );
  return mapSupportTicket(payload.ticket || payload);
}

export async function uploadSupportImage(file) {
  const base64 = await fileToDataUrl(file);
  const payload = await fetchJson(`${API_BASE}/admin/support-tickets/uploads`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({
      base64,
      contentType: file.type || 'image/jpeg',
    }),
  });
  if (!payload?.url) {
    throw new Error('No se recibió la URL de la imagen');
  }
  return payload.url;
}

function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(new Error('No se pudo leer la imagen'));
    reader.readAsDataURL(file);
  });
}
